export const physicalRiskDistributionQuery = `
  query PhysicalRiskDistribution(
    $businessCentralId: String!
    $isic: [String!]!
    $countries: [String!]!
    $physicalRiskLevels: [GqlRiskBandLevel!]!
    $dependencyLevels: [GqlRiskBandLevel!]!
    $impactLevels: [GqlRiskBandLevel!]!
    $sonLevels: [GqlSonBandLevel!]!
    $at: DateTime
  ) {
    organisation(businessCentralId: $businessCentralId, at: $at) {
      physicalRiskDistribution(
        isic: $isic
        countries: $countries
        physicalRiskLevels: $physicalRiskLevels
        dependencyLevels: $dependencyLevels
        impactLevels: $impactLevels
        sonLevels: $sonLevels
      ) {
        lowerBound
        upperBound
        count
      }
    }
  }
`;

export type PhysicalRiskDistributionResult = {
    organisation: {
        physicalRiskDistribution: Array<{
            lowerBound: number;
            upperBound: number;
            count: number;
        }>;
    } | null;
};
